import { render, staticRenderFns } from "./viewServiceInfo.vue?vue&type=template&id=859fa8b6&scoped=true"
import script from "./viewServiceInfo.vue?vue&type=script&lang=js"
export * from "./viewServiceInfo.vue?vue&type=script&lang=js"
import style0 from "./viewServiceInfo.vue?vue&type=style&index=0&id=859fa8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859fa8b6",
  null
  
)

export default component.exports